import { config as aboutYouConfig } from './about-you.config';
import { config as partnersConfig } from './partners.config';
import { config as completeConfig } from './complete-page.config';
import { config as pathConfig } from './path.config';
import { config as remoteConfig } from './remote.config';
import { config as selectDateConfig } from './select-date.config';
import { config as reviewConfig } from './review.config';
import { EDIT_PROGRESS_BAR_ITEMS, PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { ChosenPartner } from '~/components';
import { getAppointmentsDetails } from './analytics.config';
import { createHeadline } from './headline.config';
import { config as modeConfig } from './mode.config';
import { services } from '../../../services.constant';

const questionsSectionsConfig = [
  {
    key: undefined,
    title: 'Additional information',
    dataTest: 'AdditionalInformation',
  },
];

export const config = {
  ...partnersConfig,
  ...aboutYouConfig,
  ...completeConfig,
  ...pathConfig,
  ...selectDateConfig,
  ...reviewConfig,
  serviceName: services.HOME_DESIGN.name,
  PROGRESS_BAR_ITEMS,
  EDIT_PROGRESS_BAR_ITEMS,
  remote: remoteConfig,
  mode: modeConfig,
  chosenPartner: ChosenPartner,
  partnerTitle: 'Home Design Stylist',
  partnerPrefix: 'Partner & ',
  treatDropdownQuestionAsChoice: true,
  getAppointmentsDetails,
  isPartnerSelectionEnabled: true,
  questionsSectionsConfig,
  headlineTitle: createHeadline,
};
